import { CoverFeeStatus, CoverFeeType } from '@/enums/coverfee'
import { ProductTagType } from '../enums/product'
import { PromoTimeType, PromoType } from '../enums/promo'
import { RemarkGroupType, RemarkType } from '../enums/remark'

const toCamel = (s) => {
  if (typeof s === 'undefined' || s === null) {
    return s
  }
  return s.replace(/([-_][a-z])/ig, ($1) => {
    return $1.toUpperCase()
      .replace('-', '')
      .replace('_', '')
  })
}

const boolField = ($t, mapPath, { isBoolValue } = { isBoolValue: false }) => {
  if (isBoolValue) {
    return [{
      value: true,
      label: $t(mapPath + 'true')
    }, {
      value: false,
      label: $t(mapPath + 'false')
    }]
  }
  return [{
    value: 1,
    label: $t(mapPath + 'true')
  }, {
    value: 0,
    label: $t(mapPath + 'false')
  }]
}

const isString = (s) => {
  return (typeof s === 'string' || s instanceof String)
}

// translate router.meta.title, be used in breadcrumb sidebar tagsview
export function generateTitle (title) {
  const hasKey = this.$te('route.' + title)

  if (hasKey) {
    return this.$t('route.' + title)
  } else {
    var name = title.slice(0, title.lastIndexOf('.'))
    var type = title.slice(title.lastIndexOf('.') + 1)
    if (this.$te('route.' + name + '.name') && this.$te('route.default.' + type)) {
      return this.$t('route.default.' + type, this.$t('route.' + name))
    }
  }
  return title
}

export function transText (str, attr) {
  const hasKey = this.$te('api.' + str)

  if (hasKey) {
    return this.$t('api.' + str, attr)
  } else {
    var arr = str.split('.', 2)
    if (attr && this.$te('api.default.' + arr[1])) {
      return this.$t('api.default.' + arr[1], attr)
    }
    if (this.$te('api.' + arr[0] + '.name') && this.$te('api.default.' + arr[1])) {
      return this.$t('api.default.' + arr[1], this.$t('api.' + arr[0]))
    }
  }
  return str
}

export function getTransText (name, type, group) {
  const base = 'api.' + ((group) ? (group + '.fields.') : '') + name
  const optBase = 'api.optFields.' + name
  const key = base + '.' + type
  const def = 'api.default.' + type

  var ret = null
  if (this.$te(key)) {
    ret = this.$t(key)
  } else if (this.$te(def) && this.$te(base)) {
    ret = this.$t(def, this.$t(base))
  } else if (this.$te(def) && this.$te(optBase)) {
    ret = this.$t(def, this.$t(optBase))
  } else if (this.$te(base)) {
    ret = this.$t(base)
  }
  if (isString(ret)) {
    return ret
  }
  return name + '.' + type
}

export function getLabelText (base, name) {
  var cname = toCamel(name)
  const common = 'api.' + cname
  const def = 'api.' + name + '.label'
  const key = 'api.' + base + '.' + name + '.label'
  const fields = 'api.' + base + '.fields.' + name + '.label'
  const opt = 'api.optFields.' + cname + '.label'
  const sp = 'api.' + base + '.' + name
  if (this.$te(fields)) {
    return this.$t(fields)
  } else if (this.$te(common)) {
    return this.$t(common)
  } else if (this.$te(def)) {
    return this.$t(def)
  } else if (this.$te(key)) {
    return this.$t(key)
  } else if (this.$te(opt)) {
    return this.$t(opt)
  } else if (this.$te(sp)) {
    return this.$t(sp)
  }
  if (this.$te('api.' + base + '.name') && this.$te('api.default.' + name)) {
    return this.$t('api.default.' + name, this.$t('api.' + base))
  }
  return base + '.' + name
}

export function getMapLabel (map, value) {
  for (var i = 0, l = map.length; i < l; ++i) {
    if (map[i].value === value) {
      return map[i].label
    }
  }
}

export function getOptName (name, value) {
  let m = get(this.$t, name)

  return getMapLabel(m, value)
}

export function getOptMap ($t, name, type) {
  let cname = toCamel(name)
  let ctype = toCamel(type)
  switch (cname) {
    case 'ordersDiscountMode':
      cname = 'discountMode'
      break
    case 'ordersDiscountType':
      cname = 'discountType'
      break
    case 'ordersStatus':
      ctype = 'orders'
      break
    case 'invoiceStatus':
      ctype = 'invoice'
      break
    case 'giftStatus':
      ctype = 'gift'
      break
    case 'txnStatus':
      ctype = 'txn'
      break
  }

  return get($t, cname, ctype)
}

export function getDataMap (base, field) {
  switch (base + '.' + field) {
    case 'statementAttach.attach_type':
      return {
        '0': 'pdf',
        '1': 'xlsx',
        '2': 'zip'
      }
    case 'statementItem.product_type':
      return {
        '0': 'FunNow',
        '1': 'Manager',
        '2': 'Eatigo'
      }
    case 'statementItem.service_type':
      return {
        '0': 'PlatformServiceFee',
        '1': 'ProcessingFee',
        '2': 'SubscriptionFee',
        '3': 'CoverFee',
        '4': 'SMSServiceFree',
        '5': 'SMSService',
        '6': 'CollectionAdj',
        '7': 'ChargeAdj',
        // 8: Total <- Not display on item list
        '9': 'SMSTableApp',
        '10': 'SystemSetupFee',
        '11': 'PromoCode',
        '12': 'Deposit',
        '13': 'FreeCovers',
        '99': 'Other'
      }
  }
}

export function getMap (name, type) {
  return get(this.$t, name, type)
}

const get = ($t, name, type) => {
  let mapPath = 'api.optFields.' + name + '.map.'
  switch (name) {
    case 'rwgFeeType':
      return [{
        value: 0,
        label: $t(mapPath + 'false')
      }, {
        value: 3,
        label: $t(mapPath + 'basicPlan')
      }, {
        value: 1,
        label: $t(mapPath + 'silverPlan')
      }, {
        value: 2,
        label: $t(mapPath + 'goldenPlan')
      }]
    case 'bannerPlatform':
      return [{
        value: 0,
        label: $t(mapPath + 'app')
      }, {
        value: 1,
        label: $t(mapPath + 'web')
      }, {
        value: 2,
        label: $t(mapPath + 'appweb')
      }]
    case 'isDelivery':
      return boolField($t, mapPath)
    case 'pickupType':
      return [{
        value: 0,
        label: $t(mapPath + 'meetOutSide')
      }, {
        value: 1,
        label: $t(mapPath + 'atTheDoor')
      }]
    case 'courierType':
      return [{
        value: 0,
        label: $t(mapPath + 'gogox')
      }, {
        value: 1,
        label: $t(mapPath + 'branch')
      }]
    case 'deliveryStatus':
      return [{
        value: 0,
        label: $t(mapPath + 'created')
      }, {
        value: 1,
        label: $t(mapPath + 'matched')
      }, {
        value: 2,
        label: $t(mapPath + 'pickup')
      }, {
        value: 3,
        label: $t(mapPath + 'arrived')
      }, {
        value: 4,
        label: $t(mapPath + 'canceled')
      }]
    case 'deliveryFeeType':
      return [{
        value: 0,
        label: $t(mapPath + 'none')
      }, {
        value: 1,
        label: $t(mapPath + 'lessXFeeY')
      }, {
        value: 2,
        label: $t(mapPath + 'fixedFeeY')
      }]
    case 'externalType':
      return [{
        value: 0,
        label: '-'
      }, {
        value: 1,
        label: $t('api.optFields.platform.map.tableapp')
      }]
    case 'discountType':
      return [{
        value: 0,
        label: $t(mapPath + 'percent')
      }, {
        value: 1,
        label: $t(mapPath + 'amount')
      }]
    case 'discountMode':
      return [{
        value: 0,
        label: '-'
      }, {
        value: 1,
        label: $t(mapPath + 'last_minute')
      }, {
        value: 2,
        label: $t(mapPath + 'tier')
      }]
    case 'bookingType':
      return [{
        value: 0,
        label: $t(mapPath + 'online')
      }, {
        value: 1,
        label: $t(mapPath + 'merchant_phone')
      }, {
        value: 2,
        label: $t(mapPath + 'merchant_onsite')
      }]
    case 'cancelBy':
      return [{
        value: 0,
        label: $t(mapPath + 'unknown')
      }, {
        value: 1,
        label: $t(mapPath + 'system')
      }, {
        value: 2,
        label: $t(mapPath + 'admin')
      }, {
        value: 3,
        label: $t(mapPath + 'user')
      }, {
        value: 4,
        label: $t(mapPath + 'branch')
      }]
    case 'rwg':
      return [{
        value: 0,
        label: $t(mapPath + 'disabled')
      }, {
        value: 1,
        label: $t(mapPath + 'enabled')
      }]
    case 'branchRwgType':
      return [{
        value: 0,
        label: $t(mapPath + 'beauty')
      }, {
        value: 1,
        label: $t(mapPath + 'dinning')
      }]
    case 'branchRwgBrandID':
      return [{
        value: 1,
        label: $t(mapPath + 'funnow')
      }, {
        value: 3,
        label: $t(mapPath + 'eatigo')
      }]
    case 'rwgForProduct':
      return [{
        value: 0,
        label: $t(mapPath + 'disabled')
      }, {
        value: 1,
        label: $t(mapPath + 'enabled')
      }]
    case 'incapable':
      return [{
        value: 0,
        label: $t(mapPath + 'no')
      }, {
        value: 1,
        label: $t(mapPath + 'yes')
      }]
    case 'linkStatus':
      return [{
        value: 0,
        label: $t(mapPath + 'none')
      }, {
        value: 1,
        label: $t(mapPath + 'phone')
      }]
    case 'reservationSource':
      return [{
        value: 0,
        label: $t(mapPath + 'customer')
      }, {
        value: 1,
        label: $t(mapPath + 'branch')
      }, {
        value: 2,
        label: $t(mapPath + 'contactAllow')
      }, {
        value: 3,
        label: $t(mapPath + 'contactNotAllow')
      }, {
        value: 4,
        label: $t(mapPath + 'rwg')
      }, {
        value: 5,
        label: $t(mapPath + 'walkin')
      }]
    case 'funbookType':
      return [{
        value: 0,
        label: $t(mapPath + 'noProduct')
      }, {
        value: 1,
        label: $t(mapPath + 'withProduct')
      }]
    case 'funbookVer':
      return [{
        value: 1,
        label: $t(mapPath + 'v1')
      }, {
        value: 2,
        label: $t(mapPath + 'v2')
      }]
    case 'funbookPromoCodeType':
      return [{
        value: 0,
        label: $t(mapPath + 'deny')
      }, {
        value: 1,
        label: $t(mapPath + 'allow')
      }]
    case 'funbookOwnPageStatus':
      return [{
        value: 0,
        label: $t(mapPath + 'disabled')
      }, {
        value: 1,
        label: $t(mapPath + 'enabled')
      }]
    case 'ownPageType':
      return [{
        value: 0,
        label: $t(mapPath + 'subDomain')
      }, {
        value: 1,
        label: $t(mapPath + 'domain')
      }]
    case 'branchTier':
      return [{
        value: 1,
        label: $t(mapPath + 'first')
      }, {
        value: 2,
        label: $t(mapPath + 'second')
      }, {
        value: 3,
        label: $t(mapPath + 'third')
      }]
    case 'coverFeeType':
      return [{
        value: CoverFeeType.Standard,
        label: $t(mapPath + 'standard')
      }, {
        value: CoverFeeType.TimeSlot,
        label: $t(mapPath + 'timeslot')
      }]
    case 'coverFeeStatus':
      return [{
        value: CoverFeeStatus.Inactive,
        label: $t(mapPath + 'inactive')
      }, {
        value: CoverFeeStatus.Active,
        label: $t(mapPath + 'active')
      }, {
        value: CoverFeeStatus.Upcoming,
        label: $t(mapPath + 'upcoming')
      }]
    case 'templateType':
      return [{
        value: 0,
        label: $t(mapPath + 'blog')
      }, {
        value: 1,
        label: $t(mapPath + 'sttmEmail')
      }, {
        value: 9,
        label: $t(mapPath + 'soaDocumentPDF')
      }, {
        value: 18,
        label: $t(mapPath + 'soaDocumentEmail')
      }, {
        value: 2,
        label: $t(mapPath + 'slackMsg')
      }, {
        value: 3,
        label: $t(mapPath + 'consumerReceiptEmail')
      }, {
        value: 4,
        label: $t(mapPath + 'funbookReserveMail')
      }, {
        value: 5,
        label: $t(mapPath + 'funbookCancelMail')
      }, {
        value: 6,
        label: $t(mapPath + 'funbookV2ReserveMail')
      }, {
        value: 7,
        label: $t(mapPath + 'funbookV2CancelMail')
      }, {
        value: 8,
        label: $t(mapPath + 'managerOrderMail')
      }, {
        value: 10,
        label: $t(mapPath + 'ndOrderConfirmEmail')
      }, {
        value: 11,
        label: $t(mapPath + 'ndOrderCancelEmail')
      }, {
        value: 12,
        label: $t(mapPath + 'depositPaymentEmail')
      }, {
        value: 13,
        label: $t(mapPath + 'noShowConfirmMail')
      }, {
        value: 14,
        label: $t(mapPath + 'eatigoZohoTicket')
      }, {
        value: 15,
        label: $t(mapPath + 'eatigoNotifyMail')
      }, {
        value: 16,
        label: $t(mapPath + 'eatigoCancelMail')
      }, {
        value: 17,
        label: $t(mapPath + 'eatigoMemberStatusChanged')
      }, {
        value: 19,
        label: $t(mapPath + 'aosSlackMsg')
      }, {
        value: 20,
        label: $t(mapPath + 'aosGoLiveEmail')
      }]
    case 'ruleType':
      return [{
        value: 0,
        label: $t(mapPath + 'black')
      }, {
        value: 1,
        label: $t(mapPath + 'white')
      }]
    case 'matchType':
      return [{
        value: 0,
        label: $t(mapPath + 'exact')
      }, {
        value: 1,
        label: $t(mapPath + 'regex')
      }]
    case 'target':
      return [{
        value: 0,
        label: $t(mapPath + 'device')
      }, {
        value: 1,
        label: $t(mapPath + 'emailDomain')
      }, {
        value: 2,
        label: $t(mapPath + 'email')
      }, {
        value: 3,
        label: $t(mapPath + 'ccode')
      }, {
        value: 4,
        label: $t(mapPath + 'phone')
      }]
    case 'ordersSource':
      return [{
        value: 0,
        label: $t(mapPath + 'funnow')
      }, {
        value: 1,
        label: $t(mapPath + 'lineCounpon')
      }, {
        value: 2,
        label: $t(mapPath + 'lineSpot')
      }, {
        value: 3,
        label: $t(mapPath + 'ezbook')
      }, {
        value: 4,
        label: $t(mapPath + 'bookingEngine')
      }, {
        value: 5,
        label: $t(mapPath + 'partner')
      }, {
        value: 6,
        label: $t(mapPath + 'funBookV2')
      }, {
        value: 7,
        label: $t(mapPath + 'niceday')
      }, {
        value: 8,
        label: $t(mapPath + 'eatigo')
      }, {
        value: 9,
        label: $t(mapPath + 'tableapp')
      }]
    case 'cancelType':
      return [{
        value: 0,
        label: $t(mapPath + 'funnow')
      }, {
        value: 1,
        label: $t(mapPath + 'ezbook'),
        disabled: true
      }, {
        value: 2,
        label: $t(mapPath + 'custom')
      }]
    case 'fbCancelType':
      return [{
        value: 0,
        label: $t(mapPath + 'sameAsFunnow')
      }, {
        value: 1,
        label: $t(mapPath + 'custom')
      }]
    case 'branchType':
      return [{
        value: 0,
        label: $t(mapPath + 'funnow')
      }, {
        value: 1,
        label: $t(mapPath + 'funbook')
      }, {
        value: 2,
        label: $t(mapPath + 'funnow_funbook')
      }]
    case 'platform':
      return [{
        value: 0,
        label: $t(mapPath + 'funnow')
      }, {
        value: 1,
        label: $t(mapPath + 'inline')
      }, {
        value: 2,
        label: $t(mapPath + 'ebisol')
      }, {
        value: 3,
        label: $t(mapPath + 'tableapp')
      }, {
        value: 4,
        label: $t(mapPath + 'ezding')
      }, {
        value: 5,
        label: $t(mapPath + 'shalom')
      }, {
        value: 6,
        label: $t(mapPath + 'hexa')
      }, {
        value: 7,
        label: $t(mapPath + 'usen')
      }]
    case 'resourceMode':
      return [{
        value: 0,
        label: $t(mapPath + 'normal')
      }, {
        value: 1,
        label: $t(mapPath + 'tblmgmt')
      }]
    case 'assignmentMode':
      return [{
        value: 0,
        label: $t(mapPath + 'none')
      }, {
        value: 1,
        label: $t(mapPath + 'auto')
      }]
    case 'inlineTagType':
      return [{
        value: 0,
        label: $t(mapPath + 'none')
      }, {
        value: 1,
        label: $t(mapPath + 'product')
      }, {
        value: 2,
        label: $t(mapPath + 'branch')
      }]
    case 'pmsType':
      return [{
        value: 0,
        label: $t(mapPath + 'none')
      }, {
        value: 1,
        label: $t(mapPath + 'shalom')
      }, {
        value: 2,
        label: $t(mapPath + 'wise')
      }, {
        value: 3,
        label: $t(mapPath + 'dunqian')
      }, {
        value: 4,
        label: $t(mapPath + 'bistrochat')
      }]
    case 'crmType':
      return [{
        value: 0,
        label: $t(mapPath + 'none')
      }, {
        value: 1,
        label: $t(mapPath + 'ocard')
      }]
    case 'flashSale':
      return [{
        value: 0,
        label: $t(mapPath + 'disabled')
      }, {
        value: 1,
        label: $t(mapPath + 'enabled')
      }]
    case 'redirectStatus':
      return [{
        value: 0,
        label: $t(mapPath + 'disabled')
      }, {
        value: 1,
        label: $t(mapPath + 'enabled')
      }]
    case 'printStatus':
      return [{
        value: 0,
        label: $t(mapPath + 'disabled')
      }, {
        value: 1,
        label: $t(mapPath + 'enabled')
      }]
    case 'setMode':
      return [{
        value: 0,
        label: $t(mapPath + 'infinity')
      }, {
        value: 1,
        label: $t(mapPath + 'both')
      }]
    case 'reserveMode':
      return [{
        value: 0,
        label: $t(mapPath + 'productFirst')
      }, {
        value: 1,
        label: $t(mapPath + 'headcountFirst')
      }, {
        value: 2,
        label: $t(mapPath + 'selltimeFirst')
      }]
    case 'ordersRole':
      return [{
        value: 0,
        label: '-'
      }, {
        value: 1,
        label: $t(mapPath + 'main')
      }, {
        value: 2,
        label: $t(mapPath + 'sub')
      }]
    case 'regType':
    case 'authType':
      mapPath = 'api.optFields.authType.map.'
      return [{
        value: 0,
        label: $t(mapPath + 'email'),
        disabled: false
      }, {
        value: 1,
        label: $t(mapPath + 'goog'),
        disabled: false
      }, {
        value: 2,
        label: $t(mapPath + 'fb'),
        disabled: true
      }, {
        value: 3,
        label: $t(mapPath + 'guest'),
        disabled: true
      }, {
        value: 4,
        label: $t(mapPath + 'line'),
        disabled: true
      }, {
        value: 5,
        label: $t(mapPath + 'cathay'),
        disabled: true
      }, {
        value: 6,
        label: $t(mapPath + 'apple'),
        disabled: true
      }, {
        value: 7,
        label: $t(mapPath + 'tng'),
        disabled: true
      }, {
        value: 8,
        label: $t(mapPath + 'rwg'),
        disabled: true
      }, {
        value: 9,
        label: $t(mapPath + 'partner'),
        disabled: true
      }, {
        value: 10,
        label: $t(mapPath + 'anonymous'),
        disabled: true
      }]
    case 'mfaEnabled':
      return boolField($t, mapPath)
    case 'preferType':
      return boolField($t, mapPath)
    case 'permType':
      return [{
        value: 0,
        label: $t(mapPath + 'none')
      }, {
        value: 1,
        label: $t(mapPath + 'role')
      }, {
        value: 2,
        label: $t(mapPath + 'all')
      }]
    case 'policyType':
      return [{
        value: 0,
        label: $t(mapPath + 'allow')
      }, {
        value: 1,
        label: $t(mapPath + 'deny')
      }]
    case 'limitPeriod':
      return [{
        value: 1,
        label: $t(mapPath + 'sunday')
      }, {
        value: 2,
        label: $t(mapPath + 'monday')
      }, {
        value: 4,
        label: $t(mapPath + 'tuesday')
      }, {
        value: 8,
        label: $t(mapPath + 'wednesday')
      }, {
        value: 16,
        label: $t(mapPath + 'thursday')
      }, {
        value: 32,
        label: $t(mapPath + 'friday')
      }, {
        value: 64,
        label: $t(mapPath + 'saturday')
      }]
    case 'firstPurchaseLimit':
      return [{
        value: 0,
        label: $t(mapPath + 'unlimit')
      }, {
        value: 1,
        label: $t(mapPath + 'limit')
      }]
    case 'promoApplicablePlatform':
      return [{
        value: 0,
        label: $t(mapPath + 'funnow')
      }, {
        value: 1,
        label: $t(mapPath + 'funnow_booking')
      }]
    case 'promoCostAllocation':
      return [{
        value: 0,
        label: $t(mapPath + 'funnow')
      }, {
        value: 1,
        label: $t(mapPath + 'merchant')
      }]
    case 'role':
      return [{
        value: 0,
        label: $t(mapPath + 'default')
      }, {
        value: 1,
        label: $t(mapPath + 'funbook')
      }]
    case 'ordersStatus':
      mapPath = 'api.optFields.status.map.'
      return getStatusMap($t, mapPath, type)
    case 'invoiceStatus':
      mapPath = 'api.optFields.status.map.'
      return getStatusMap($t, mapPath, type)
    case 'giftStatus':
      mapPath = 'api.optFields.status.map.'
      return getStatusMap($t, mapPath, type)
    case 'txnStatus':
      mapPath = 'api.optFields.status.map.'
      return getStatusMap($t, mapPath, type)
    case 'status':
      return getStatusMap($t, mapPath, type)
    case 'showall':
      return [{
        value: 0,
        label: $t(mapPath + 'no')
      }, {
        value: 1,
        label: $t(mapPath + 'yes')
      }]
    case 'sendSMS':
      return [{
        value: 0,
        label: $t(mapPath + 'no')
      }, {
        value: 1,
        label: $t(mapPath + 'yes')
      }]
    case 'onBoard':
      return [{
        value: 0,
        label: $t(mapPath + 'ok')
      }, {
        value: 1,
        label: $t(mapPath + 'not')
      }]
    case 'tagType':
      return [{
        value: ProductTagType.Facility,
        label: $t(mapPath + 'facility')
      }, {
        value: ProductTagType.Category,
        label: $t(mapPath + 'category')
      }, {
        value: ProductTagType.Normal,
        label: $t(mapPath + 'normal')
      }, {
        value: ProductTagType.Event,
        label: $t(mapPath + 'event')
      }, {
        value: ProductTagType.FlashSale,
        label: $t(mapPath + 'flash')
      }, {
        value: ProductTagType.Uniq,
        label: $t(mapPath + 'uniq')
      }, {
        value: ProductTagType.Review,
        label: $t(mapPath + 'review')
      }, {
        value: ProductTagType.UserRights,
        label: $t(mapPath + 'user_rights')
      }, {
        value: ProductTagType.RegionLabel,
        label: $t(mapPath + 'region_label')
      }, {
        value: ProductTagType.Cuisine,
        label: $t(mapPath + 'cuisine')
      }, {
        value: ProductTagType.ServiceLanguage,
        label: $t(mapPath + 'service_language')
      }, {
        value: ProductTagType.PaymentMethod,
        label: $t(mapPath + 'payment_method')
      }, {
        value: ProductTagType.Atmosphere,
        label: $t(mapPath + 'atmosphere')
      }, {
        value: ProductTagType.SpecialDiet,
        label: $t(mapPath + 'special_diet')
      }, {
        value: ProductTagType.CardVerification,
        label: $t(mapPath + 'card_verification')
      }, {
        value: ProductTagType.NLPData,
        label: $t(mapPath + 'nlp_data')
      }, {
        value: ProductTagType.Chatbot,
        label: $t(mapPath + 'chatbot')
      }]
    case 'remarkType':
      return [{
        value: RemarkType.TextField,
        label: $t(mapPath + 'text')
      }, {
        value: RemarkType.Date,
        label: $t(mapPath + 'date')
      }, {
        value: RemarkType.DateTime,
        label: $t(mapPath + 'datetime')
      }, {
        value: RemarkType.Radio,
        label: $t(mapPath + 'radio')
      }, {
        value: RemarkType.Quantity,
        label: $t(mapPath + 'quantity')
      }, {
        value: RemarkType.MobileNumber,
        label: $t(mapPath + 'mobile')
      }, {
        value: RemarkType.Checkbox,
        label: $t(mapPath + 'checkbox')
      }, {
        value: RemarkType.PureText,
        label: $t(mapPath + 'text_description')
      },
      {
        value: RemarkType.Picture,
        label: $t(mapPath + 'image_description')
      }]
    case 'remarkRegex':
      return [{
        value: 0,
        label: $t(mapPath + 'none')
      }, {
        value: 1,
        label: $t(mapPath + 'TWMobile')
      }, {
        value: 2,
        label: $t(mapPath + 'GlobalMobile')
      }]
    case 'remarkGroupType':
      return [{
        value: RemarkGroupType.Order,
        label: $t(mapPath + 'OrderRemark')
      }, {
        value: RemarkGroupType.Attendee,
        label: $t(mapPath + 'AttendeeForm')
      }]
    case 'eventType':
      return [{
        value: 0,
        label: $t(mapPath + 'sign')
      }, {
        value: 1,
        label: $t(mapPath + 'renew')
      }, {
        value: 16,
        label: $t(mapPath + 'short')
      }, {
        value: 17,
        label: $t(mapPath + 'event')
      }, {
        value: 5,
        label: $t(mapPath + 'closed')
      }, {
        value: 2,
        label: $t(mapPath + 'term')
      }, {
        value: 6,
        label: $t(mapPath + 'nosale')
      }, {
        value: 18,
        label: $t(mapPath + 'nosaleTemp')
      }, {
        value: 9,
        label: $t(mapPath + 'onsale')
      }, {
        value: 3,
        label: $t(mapPath + 'reg')
      }, {
        value: 4,
        label: $t(mapPath + 'fee')
      }, {
        value: 7,
        label: $t(mapPath + 'feeReturn')
      }, {
        value: 8,
        label: $t(mapPath + 'feeConfiscate')
      }, {
        value: 10,
        label: $t(mapPath + 'chargeFee')
      }, {
        value: 11,
        label: $t(mapPath + 'googleDone')
      }, {
        value: 12,
        label: $t(mapPath + 'tripadvisorDone')
      }, {
        value: 13,
        label: $t(mapPath + 'ifoodieDone')
      }, {
        value: 14,
        label: $t(mapPath + 'lineSpotDone')
      }, {
        value: 15,
        label: $t(mapPath + 'fbIGWebDone')
      }]
    case 'paymentStatus':
      return [{
        value: 0,
        label: $t(mapPath + 'normal')
      }, {
        value: 1,
        label: $t(mapPath + 'argument')
      }]
    case 'oa':
      return [{
        value: 0,
        label: $t(mapPath + 'monthly')
      }, {
        value: 1,
        label: $t(mapPath + 'halfMonthly')
      }]
    case 'issueInvoice':
      return [{
        value: 0,
        label: $t(mapPath + 'disabled')
      }, {
        value: 1,
        label: $t(mapPath + 'enabled')
      }]
    case 'fbIssueInvoice':
      return [{
        value: 0,
        label: $t(mapPath + 'disabled')
      }, {
        value: 1,
        label: $t(mapPath + 'enabled')
      }]
    case 'invoiceType':
      return [{
      /*
        value: -1,
        label: $t(mapPath + 'unknown'),
        disabled: true
      }, {
      */
        value: 0,
        label: $t(mapPath + 'invoice')
      }, {
      /*
        value: 1,
        label: $t(mapPath + 'merchant')
      }, {
      */
        value: 2,
        label: $t(mapPath + 'receipt')
      }, {
        value: 3,
        label: $t(mapPath + 'mutual')
      }, {
        value: 4,
        label: $t(mapPath + 'personal')
      }, {
        value: 5,
        label: $t(mapPath + 'mutualReceipt')
      }]
    case 'txnType':
      return [{
        value: -1,
        label: $t(mapPath + 'ordersAdmin')
      }, {
        value: 0,
        label: $t(mapPath + 'allpay')
      }, {
        value: 1,
        label: $t(mapPath + 'braintree')
      }, {
        value: 2,
        label: $t(mapPath + 'ctbc')
      }, {
        value: 3,
        label: $t(mapPath + 'tappay')
      }, {
        value: 4,
        label: $t(mapPath + 'applepay')
      }, {
        value: 5,
        label: $t(mapPath + 'googlepay')
      }, {
        value: 6,
        label: $t(mapPath + 'none')
      }, {
        value: 7,
        label: $t(mapPath + 'linepay')
      }, {
        value: 8,
        label: $t(mapPath + 'molpay')
      }, {
        value: 9,
        label: $t(mapPath + 'grabpay')
      }, {
        value: 10,
        label: $t(mapPath + 'ipay88FPX')
      }, {
        value: 11,
        label: $t(mapPath + 'stripeHK')
      }, {
        value: 12,
        label: $t(mapPath + 'stripeJP')
      }, {
        value: 13,
        label: $t(mapPath + 'stripeGooglePayHK')
      }, {
        value: 14,
        label: $t(mapPath + 'stripeGooglePayJP')
      }, {
        value: 15,
        label: $t(mapPath + 'stripeApplePayHK')
      }, {
        value: 16,
        label: $t(mapPath + 'stripeApplePayJP')
      }, {
        value: 17,
        label: $t(mapPath + 'tngwallet')
      }, {
        value: 18,
        label: $t(mapPath + 'atmToMerchant')
      }, {
        value: 19,
        label: $t(mapPath + 'piwallet')
      }, {
        value: 20,
        label: $t(mapPath + 'octopus')
      }, {
        value: 21,
        label: $t(mapPath + 'partner')
      }, {
        value: 22,
        label: $t(mapPath + 'funBookNoPayment')
      }, {
        value: 23,
        label: $t(mapPath + 'stripeTH')
      }, {
        value: 24,
        label: $t(mapPath + 'stripeMY')
      }, {
        value: 25,
        label: $t(mapPath + 'stripeGooglePayTH')
      }, {
        value: 26,
        label: $t(mapPath + 'stripeGooglePayMY')
      }, {
        value: 27,
        label: $t(mapPath + 'stripeApplePayTH')
      }, {
        value: 28,
        label: $t(mapPath + 'stripeApplePayMY')
      }, {
        value: 29,
        label: $t(mapPath + 'promptpay')
      }, {
        value: 30,
        label: $t(mapPath + 'tappayInstallments3')
      }, {
        value: 31,
        label: $t(mapPath + 'tableappDeposit')
      }]
    case 'giftType':
      return [{
        value: 0,
        label: $t(mapPath + 'sender')
      }, {
        value: 1,
        label: $t(mapPath + 'receiver')
      }]
    case 'salesMode':
      return [{
        value: 0,
        label: $t(mapPath + 'normal')
      }, {
        value: 1,
        label: $t(mapPath + 'weekend'),
        disabled: true
      }, {
        value: 2,
        label: $t(mapPath + 'cert')
      }, {
        value: 3,
        label: $t(mapPath + 'delivery')
      }, {
        value: 4,
        label: $t(mapPath + 'alcoholDelivery')
      }, {
        value: 5,
        label: $t(mapPath + 'movie'),
        disabled: true
      }, {
        value: 6,
        label: $t(mapPath + 'camping')
      }]
    case 'timeMode':
      // options are ordered by days
      return [{
        value: 0,
        label: $t(mapPath + 'default')
      }, {
        value: 1,
        label: $t(mapPath + 'calendar')
      }, {
        value: 3,
        label: $t(mapPath + 'calendar60days')
      }, {
        value: 4,
        label: $t(mapPath + 'calendar90days')
      }, {
        value: 2,
        label: $t(mapPath + 'calendar180days')
      }, {
        value: 5,
        label: $t(mapPath + 'calendar365days')
      }]
    case 'dayMode':
      // options are ordered by days
      return [{
        value: 0,
        label: $t(mapPath + 'default')
      }, {
        value: 1,
        label: $t(mapPath + 'calendar')
      }, {
        value: 3,
        label: $t(mapPath + 'calendar60days')
      }, {
        value: 4,
        label: $t(mapPath + 'calendar90days')
      }, {
        value: 2,
        label: $t(mapPath + 'calendar180days')
      }, {
        value: 5,
        label: $t(mapPath + 'calendar365days')
      }]
    case 'popularMode':
      return [{
        value: 0,
        label: $t(mapPath + 'auto')
      }, {
        value: 1,
        label: $t(mapPath + 'manual')
      }]
    case 'refPriceMode':
      return [{
        value: 0,
        label: $t(mapPath + 'auto')
      }, {
        value: 1,
        label: $t(mapPath + 'manual')
      }]
    case 'cancelable':
      return boolField($t, mapPath)
    case 'giftable':
      return boolField($t, mapPath)
    case 'coolingOff':
      return boolField($t, mapPath)
    case 'noShowPenalty':
      return boolField($t, mapPath)
    case 'ordersType':
      return [{
        value: null,
        label: $t(mapPath + 'normal')
      }, {
        value: 0,
        label: $t(mapPath + 'sender')
      }, {
        value: 1,
        label: $t(mapPath + 'receiver')
      }]
    case 'reschedulable':
      return boolField($t, mapPath)
    case 'attendees':
      return boolField($t, mapPath)
    case 'is_on_site_payment_discount':
      return boolField($t, mapPath)
    case 'reservations_mode':
      return [{
        value: 0,
        label: $t(mapPath + 'auto')
      }, {
        value: 1,
        label: $t(mapPath + 'manual')
      }]
    case 'editMode':
      return [{
        value: 0,
        label: $t(mapPath + 'none')
      }, {
        value: 1,
        label: $t(mapPath + 'managerNotAllow')
      }]
    case 'newReleaseMode':
      return [{
        value: 0,
        label: $t(mapPath + 'auto')
      }, {
        value: 1,
        label: $t(mapPath + 'manual')
      }]
    case 'hasTimeFilter':
      return boolField($t, mapPath)
    case 'hasCustNum':
      return boolField($t, mapPath)
    case 'hasCrossDay':
      return boolField($t, mapPath)
    case 'isCrossDay':
      return boolField($t, mapPath)
    case 'isCustNum':
      return boolField($t, mapPath)
    case 'isOccuResource':
      return boolField($t, mapPath)
    case 'isEmailSent':
      return boolField($t, mapPath)
    case 'canGroup':
      return boolField($t, mapPath, { isBoolValue: true })
    case 'weekday':
      return [{
        value: 0,
        label: $t(mapPath + 'sunday')
      }, {
        value: 1,
        label: $t(mapPath + 'monday')
      }, {
        value: 2,
        label: $t(mapPath + 'tuesday')
      }, {
        value: 3,
        label: $t(mapPath + 'wednesday')
      }, {
        value: 4,
        label: $t(mapPath + 'thursday')
      }, {
        value: 5,
        label: $t(mapPath + 'friday')
      }, {
        value: 6,
        label: $t(mapPath + 'saturday')
      }]
    case 'salesRangeType':
      return [{
        value: 0,
        label: $t(mapPath + 'normal')
      }, {
        value: 1,
        label: $t(mapPath + 'suspension')
      }]
    case 'showOn':
      return [{
        value: 0,
        label: $t(mapPath + 'funnow')
      }, {
        value: 1,
        label: $t(mapPath + 'funbook')
      }, {
        value: 2,
        label: $t(mapPath + 'funnow_funbook')
      }]
    case 'ycMode':
      return [{
        value: 0,
        label: $t(mapPath + 'no')
      }, {
        value: 1,
        label: $t(mapPath + 'yes')
      }]
    case 'bookingMode':
      return [{
        value: 0,
        label: $t(mapPath + 'normal')
      }, {
        value: 1,
        label: $t(mapPath + 'seatOnly')
      }]
    case 'paymentMode':
      return [{
        value: 0,
        label: $t(mapPath + 'online')
      }, {
        value: 1,
        label: $t(mapPath + 'onsite')
      }]
    case 'soaReceiptPaymentMode':
      return [{
        value: 0,
        label: $t(mapPath + 'autoCreate')
      }, {
        value: 1,
        label: $t(mapPath + 'cheque')
      }, {
        value: 2,
        label: $t(mapPath + 'bankTransfer')
      }]
    case 'detailMode':
      return [{
        value: 0,
        label: $t(mapPath + 'hidden')
      }, {
        value: 1,
        label: $t(mapPath + 'display')
      }]
    case 'linkType':
      return [{
        value: 0,
        label: $t(mapPath + 'none')
      }, {
        value: 1,
        label: $t(mapPath + 'url')
      }, {
        value: 2,
        label: $t(mapPath + 'absolutePath')
      }, {
        value: 3,
        label: $t(mapPath + 'relativePath')
      }]
    case 'webLinkType':
      return [{
        value: 0,
        label: $t(mapPath + 'none')
      }, {
        value: 1,
        label: $t(mapPath + 'url')
      }, {
        value: 3,
        label: $t(mapPath + 'relativePath')
      }]
    case 'listType':
      return [{
        value: 0,
        label: $t(mapPath + 'main')
      }, {
        value: 1,
        label: $t(mapPath + 'add')
      }, {
        value: 2,
        label: $t(mapPath + 'both'),
        disabled: true
      }]
    case 'addType':
      return [{
        value: 0,
        label: $t(mapPath + 'none')
      }, {
        value: 1,
        label: $t(mapPath + 'all')
      }, {
        value: 2,
        label: $t(mapPath + 'custom')
      }]
    case 'allowMulti':
      return [{
        value: 0,
        label: $t(mapPath + 'no')
      }, {
        value: 1,
        label: $t(mapPath + 'allow')
      }]
    case 'refundType':
      return [{
        value: 0,
        label: $t(mapPath + 'refund100')
      }, {
        value: 1,
        label: $t(mapPath + 'refund70')
      }, {
        value: 2,
        label: $t(mapPath + 'refund70release')
      }, {
        value: 3,
        label: $t(mapPath + 'refund70refund')
      }, {
        value: 4,
        label: $t(mapPath + 'allowance')
      }]
    case 'newsType':
      return [{
        value: 0,
        label: $t(mapPath + 'system')
      }, {
        value: 1,
        label: $t(mapPath + 'txn')
      }, {
        value: 2,
        label: $t(mapPath + 'ad')
      }, {
        value: 3,
        label: $t(mapPath + 'promo_code')
      }, {
        value: 4,
        label: $t(mapPath + 'gift_fun')
      }]
    case 'newsAct':
      return [{
        value: 0,
        label: $t(mapPath + 'none')
      }, {
        value: 1,
        label: $t(mapPath + 'url')
      }, {
        value: 2,
        label: $t(mapPath + 'app_link')
      }]
    case 'stInvoiceStatus':
      return [{
        value: 0,
        label: $t(mapPath + 'none')
      }, {
        value: 1,
        label: $t(mapPath + 'received')
      }, {
        value: 2,
        label: $t(mapPath + 'replied')
      }]
    case 'transferStatus':
      return [{
        value: 0,
        label: $t(mapPath + 'none')
      }, {
        value: 1,
        label: $t(mapPath + 'transfered')
      }]
    case 'noTransStatus':
      return [{
        value: 0,
        label: $t(mapPath + 'none')
      }, {
        value: 1,
        label: $t(mapPath + 'errTitle')
      }, {
        value: 2,
        label: $t(mapPath + 'errInvoice')
      }, {
        value: 3,
        label: $t(mapPath + 'errTax')
      }, {
        value: 4,
        label: $t(mapPath + 'errInfo')
      }, {
        value: 5,
        label: $t(mapPath + 'other')
      }, {
        value: 6,
        label: $t(mapPath + 'handled')
      }]
    case 'gender':
      return [{
        value: null,
        label: $t(mapPath + 'none')
      }, {
        value: 0,
        label: $t(mapPath + 'female')
      }, {
        value: 1,
        label: $t(mapPath + 'male')
      }, {
        value: 2,
        label: $t(mapPath + 'other')
      }, {
        value: 3,
        label: $t(mapPath + 'not_disclosed')
      }]
    case 'blogger':
      return boolField($t, mapPath)
    case 'pushStatus':
      return [{
        value: 0,
        label: $t(mapPath + 'true')
      }, {
        value: 1,
        label: $t(mapPath + 'false')
      }]
    case 'historyStatus':
      return [{
        value: 0,
        label: $t(mapPath + 'true')
      }, {
        value: 1,
        label: $t(mapPath + 'false')
      }]
    case 'bhdEditable':
      return boolField($t, mapPath)
    case 'promoType':
      return [{
        value: PromoType.FunCoin,
        label: $t(mapPath + 'fun_coin')
      }, {
        value: PromoType.GreaterYGiveX,
        label: $t(mapPath + 'fixed_promo')
      }, {
        value: PromoType.XOffLimitYThresholdZ,
        label: $t(mapPath + 'percent_promo')
      }, {
        value: PromoType.Elite,
        label: $t(mapPath + 'elite')
      }, {
        value: PromoType.Onsite,
        label: $t(mapPath + 'onsite_prop')
      }]
    case 'promoTimeType':
      return [{
        value: PromoTimeType.Range,
        label: $t(mapPath + 'range')
      }, {
        value: PromoTimeType.Day,
        label: $t(mapPath + 'day')
      }, {
        value: PromoTimeType.Month,
        label: $t(mapPath + 'month')
      }]
    case 'promoCardType':
      return [{
        value: 1,
        label: $t(mapPath + 'visa')
      }]
    case 'promoSpecifiedTxnCurrencyID':
      return [{
        value: null,
        label: $t(mapPath + 'unlimit')
      }, {
        value: 0,
        label: $t(mapPath + 'TWD')
      }, {
        value: 3,
        label: $t(mapPath + 'MYR')
      }]
    case 'promoCardFunding':
      return [{
        value: 'Debit Card',
        label: $t(mapPath + 'debitCard')
      }, {
        value: 'Credit Card',
        label: $t(mapPath + 'creditCard')
      }]
    case 'promoCardLevel':
      return [{
        value: 'CLASSIC',
        label: $t(mapPath + 'visaClassic')
      }, {
        value: 'GOLD',
        label: $t(mapPath + 'visaGold')
      }, {
        value: 'PLATINUM',
        label: $t(mapPath + 'visaPlatinum')
      }, {
        value: 'SIGNATURE',
        label: $t(mapPath + 'visaSignature')
      }, {
        value: 'INFINITE',
        label: $t(mapPath + 'visaInfinite')
      }, {
        value: 'BUSINESS',
        label: $t(mapPath + 'visaBusiness')
      }, {
        value: 'BUSINESS SIGNATURE',
        label: $t(mapPath + 'visaBusinessSignature')
      }, {
        value: 'BUSINESS INFINITE',
        label: $t(mapPath + 'visaBusinessInfinite')
      }]
    case 'promoIsDiscountMovieFee':
      return [{
        value: 1,
        label: $t(mapPath + 'true')
      }, {
        value: 0,
        label: $t(mapPath + 'false')
      }]
    case 'participationType':
      return [{
        value: 0,
        label: $t(mapPath + 'unlimit')
      }, {
        value: 1,
        label: $t(mapPath + 'limit')
      }]
    case 'timeType':
      return [{
        value: 0,
        label: $t(mapPath + 'range')
      }, {
        value: 1,
        label: $t(mapPath + 'day')
      }]
    case 'memberMissionType':
      return [{
        value: 0,
        label: $t(mapPath + 'fun_coin')
      }, {
        value: 1,
        label: $t(mapPath + 'mile')
      }]
    case 'isCreditLimit':
      return [{
        value: 0,
        label: $t(mapPath + 'unlimit')
      }, {
        value: 1,
        label: $t(mapPath + 'limit')
      }]
    case 'print':
      return [{
        value: '',
        label: $t(mapPath + 'none')
      }, {
        value: '0',
        label: $t(mapPath + 'false')
      }, {
        value: '1',
        label: $t(mapPath + 'true')
      }]
    case 'clearanceMark':
      return [{
        value: '',
        label: $t(mapPath + 'none')
      }, {
        value: '1',
        label: $t(mapPath + 'yes')
      }, {
        value: '2',
        label: $t(mapPath + 'no')
      }]
    case 'donation':
      return [{
        value: '',
        label: $t(mapPath + 'none')
      }, {
        value: '1',
        label: $t(mapPath + 'yes')
      }, {
        value: '2',
        label: $t(mapPath + 'no')
      }]
    case 'taxType':
      return [{
        value: '1',
        label: $t(mapPath + 'yes')
      }, {
        value: '2',
        label: $t(mapPath + 'zero')
      }, {
        value: '3',
        label: $t(mapPath + 'no')
      }]
    case 'carruerType':
      return [{
        value: '',
        label: $t(mapPath + 'none')
      }, {
        value: '1',
        label: $t(mapPath + 'member')
      }, {
        value: '2',
        label: $t(mapPath + 'nature')
      }, {
        value: '3',
        label: $t(mapPath + 'mobile')
      }]
    case 'upgradeMode':
      return [{
        value: 0,
        label: $t(mapPath + 'no')
      }, {
        value: 1,
        label: $t(mapPath + 'yes')
      }]
    case 'vat':
      return [{
        value: '0',
        label: $t(mapPath + 'not')
      }, {
        value: '1',
        label: $t(mapPath + 'include')
      }]
    case 'vatType':
      return [{
        value: 0,
        label: $t(mapPath + 'registered')
      }, {
        value: 1,
        label: $t(mapPath + 'zero')
      }, {
        value: 2,
        label: $t(mapPath + 'exempt')
      }]
    case 'invType':
      return [{
        value: '07',
        label: $t(mapPath + 'normal')
      }, {
        value: '08',
        label: $t(mapPath + 'special')
      }]
    case 'limitType':
      return [{
        value: 0,
        label: $t(mapPath + 'none')
      }, {
        value: 1,
        label: $t(mapPath + 'sameAsCustNum')
      }]
    case 'limitMinType':
      return [{
        value: 0,
        label: $t(mapPath + 'none')
      }, {
        value: 1,
        label: $t(mapPath + 'sameAsCustNum')
      }]
    case 'lineSpotSync':
      return boolField($t, mapPath)
    case 'categoryType':
      return [{
        value: 0,
        label: $t(mapPath + 'category')
      }, {
        value: 1,
        label: $t(mapPath + 'themes')
      }, {
        value: 2,
        label: $t(mapPath + 'filter')
      }, {
        value: 3,
        label: $t(mapPath + 'cuisine')
      }, {
        value: 4,
        label: $t(mapPath + 'brand')
      }, {
        value: 5,
        label: $t(mapPath + 'location')
      }]
    case 'receiptType':
      return [{
        value: 0,
        label: $t(mapPath + 'payment')
      }, {
        value: 1,
        label: $t(mapPath + 'refund')
      }]
    case 'statementTmpl':
      return [{
        value: 'TW',
        label: $t(mapPath + 'tw')
      }, {
        value: 'HK',
        label: $t(mapPath + 'hk')
      }, {
        value: 'JP',
        label: $t(mapPath + 'jp')
      }, {
        value: 'MY',
        label: $t(mapPath + 'my')
      }, {
        value: 'TH',
        label: $t(mapPath + 'th')
      }]
    case 'sendReceipt':
      return [{
        value: 0,
        label: $t(mapPath + 'disabled')
      }, {
        value: 1,
        label: $t(mapPath + 'enabled')
      }]
    case 'remainMode':
      return [{
        value: 0,
        label: $t(mapPath + 'disabled')
      }, {
        value: 1,
        label: $t(mapPath + 'enabled')
      }]
    case 'partnerProductStatus':
      return [{
        value: -1,
        label: $t(mapPath + 'noneUpload')
      }, {
        value: 0,
        label: $t(mapPath + 'noSale')
      }, {
        value: 1,
        label: $t(mapPath + 'onSale')
      }]
    case 'source':
      return [{
        value: 0,
        label: $t(mapPath + 'default')
      }, {
        value: 1,
        label: $t(mapPath + 'brand')
      }, {
        value: 2,
        label: $t(mapPath + 'set')
      }]
    case 'ordersStatementStatus':
      return boolField($t, mapPath)
    case 'feeBeBorneBy':
      return [{
        value: 0,
        label: $t(mapPath + 'merchant')
      }, {
        value: 1,
        label: $t(mapPath + 'funnow')
      }]
    case 'isReceiptInStmt':
      return boolField($t, mapPath)
    case 'isFreeOfCharge':
      return boolField($t, mapPath)
    case 'refundDiffStatus':
      return boolField($t, mapPath)
    case 'attendStatus':
      return [{
        value: 0,
        label: $t(mapPath + 'attended')
      }, {
        value: 1,
        label: $t(mapPath + 'noShow')
      }, {
        value: 2,
        label: $t(mapPath + 'cancel')
      }]
    case 'documentType':
      return [{
        value: 0,
        label: $t(mapPath + 'invoice')
      }, {
        value: 1,
        label: $t(mapPath + 'depositInvoice')
      }, {
        value: 2,
        label: $t(mapPath + 'creditNote')
      }, {
        value: 3,
        label: $t(mapPath + 'debitNote')
      }, {
        value: 4,
        label: $t(mapPath + 'receipt')
      }]
    case 'documentStatus':
      return [{
        value: 0,
        label: $t(mapPath + 'normal')
      }, {
        value: 1,
        label: $t(mapPath + 'void')
      }]
    case 'documentDueDateType':
      return [{
        value: 0,
        label: $t(mapPath + 'none')
      }, {
        value: 1,
        label: $t(mapPath + 'immediate')
      }, {
        value: 2,
        label: $t(mapPath + 'netDays')
      }]
    case 'invoiceDueDateType':
      return [{
        value: 1,
        label: $t(mapPath + 'immediate')
      }, {
        value: 2,
        label: $t(mapPath + 'netDays')
      }]
    case 'itemProductType':
      return [{
        value: 0,
        label: $t(mapPath + 'funnow')
      }, {
        value: 2,
        label: $t(mapPath + 'eatigo')
      }, {
        value: 1,
        label: $t(mapPath + 'manager')
      }]
    case 'itemServiceType':
      return [{
        value: 12,
        label: $t(mapPath + 'deposit')
      }, {
        value: 0,
        label: $t(mapPath + 'platformServiceFee')
      }, {
        value: 1,
        label: $t(mapPath + 'processingFee')
      }, {
        value: 2,
        label: $t(mapPath + 'subscriptionFee')
      }, {
        value: 10,
        label: $t(mapPath + 'systemSetupFee')
      }, {
        value: 3,
        label: $t(mapPath + 'coverFee')
      }, {
        value: 4,
        label: $t(mapPath + 'smsServiceFeeFree')
      }, {
        value: 5,
        label: $t(mapPath + 'smsServiceFee')
      }, {
        value: 6,
        label: $t(mapPath + 'collectionAdj')
      }, {
        value: 7,
        label: $t(mapPath + 'chargeAdj')
      }, {
        value: 8,
        label: $t(mapPath + 'total')
      }, {
        value: 9,
        label: $t(mapPath + 'smsTableapp')
      }, {
        value: 11,
        label: $t(mapPath + 'promoCode')
      }, {
        value: 13,
        label: $t(mapPath + 'freeCovers')
      }, {
        value: 99,
        label: $t(mapPath + 'other')
      }]
    case 'attachType':
      return [{
        value: 0,
        label: $t(mapPath + 'pdf')
      }, {
        value: 1,
        label: $t(mapPath + 'xlsx')
      }, {
        value: 2,
        label: $t(mapPath + 'zip')
      }]
    case 'documentVATApplyType':
      return [{
        value: 0,
        label: $t(mapPath + 'sameAsBranch')
      }, {
        value: 1,
        label: $t(mapPath + 'exempt')
      }]
    case 'noteType':
      return [{
        value: 0,
        label: $t(mapPath + 'debit')
      }, {
        value: 1,
        label: $t(mapPath + 'credit')
      }]
    case 'soaInvoiceType':
      return [{
        value: 0,
        label: $t(mapPath + 'general')
      }, {
        value: 2,
        label: $t(mapPath + 'deposit')
      }, {
        value: 1,
        label: $t(mapPath + 'custom')
      }]
    case 'isECV':
      return boolField($t, mapPath)
    case 'attendance_history_type':
      mapPath = 'api.user.fields.attendance_type.map.'
      return [{
        value: 0,
        label: $t(mapPath + 'no_show')
      }, {
        value: 1,
        label: $t(mapPath + 'revoke_noshow')
      }, {
        value: 2,
        label: $t(mapPath + 'suspended')
      }, {
        value: 3,
        label: $t(mapPath + 'reactivation')
      }]
    case 'branchBUStatus':
      return [{
        value: 0,
        label: $t(mapPath + 'none')
      }, {
        value: 1,
        label: $t(mapPath + 'onboarding')
      }, {
        value: 2,
        label: $t(mapPath + 'verification')
      }, {
        value: 3,
        label: $t(mapPath + 'live')
      }, {
        value: 4,
        label: $t(mapPath + 'active')
      }, {
        value: 5,
        label: $t(mapPath + 'suspended')
      }, {
        value: 6,
        label: $t(mapPath + 'inactive')
      }, {
        value: 7,
        label: $t(mapPath + 'churn')
      }, {
        value: 8,
        label: $t(mapPath + 'nwa')
      }]
    case 'hexaCommissionType':
      return [{
        value: 0,
        label: $t(mapPath + 'include')
      }, {
        value: 1,
        label: $t(mapPath + 'exclude')
      }]
    case 'hexaSyncType':
      return [{
        value: 0,
        label: $t(mapPath + 'overnight')
      }, {
        value: 1,
        label: $t(mapPath + 'rest')
      }]
    case 'hexaSyncSetType':
      return [{
        value: 0,
        label: $t(mapPath + 'default')
      }, {
        value: 1,
        label: $t(mapPath + 'range')
      }]
    case 'hexaSyncResourceType':
      return [{
        value: 0,
        label: $t(mapPath + 'disabled')
      }, {
        value: 1,
        label: $t(mapPath + 'enabled')
      }]
    case 'hexaSyncPriceType':
      return [{
        value: 0,
        label: $t(mapPath + 'disabled')
      }, {
        value: 1,
        label: $t(mapPath + 'enabled')
      }]
    case 'redeemStatus':
      return [{
        value: 'no_show',
        label: $t(mapPath + 'noShow')
      }, {
        value: 'redeemed',
        label: $t(mapPath + 'redeemed')
      }, {
        value: 'unredeemed',
        label: $t(mapPath + 'unredeemed')
      }]
    case 'penaltyType':
      return [{
        value: 0,
        label: $t(mapPath + 'cancel')
      }, {
        value: 1,
        label: $t(mapPath + 'noShow')
      }]
    case 'penaltyChargeType':
      return [{
        value: 0,
        label: $t(mapPath + 'noCharge')
      }, {
        value: 1,
        label: $t(mapPath + 'penalty')
      }]
    case 'funCoinType':
      return [{
        value: 0,
        label: $t(mapPath + 'disabled')
      }, {
        value: 1,
        label: $t(mapPath + 'enabled')
      }]
  }
  return []
}

function getStatusMap ($t, mapPath, type) {
  switch (type) {
    case 'aosForm':
      mapPath = mapPath + 'aosForm.'
      return [{
        value: 0,
        label: $t(mapPath + 'draft')
      }, {
        value: 1,
        label: $t(mapPath + 'submitted')
      }, {
        value: 2,
        label: $t(mapPath + 'rejected')
      }, {
        value: 3,
        label: $t(mapPath + 'approved')
      }, {
        value: 4,
        label: $t(mapPath + 'syncing')
      }, {
        value: 5,
        label: $t(mapPath + 'synced')
      }]
    case 'service':
      return [{
        value: 0,
        label: $t(mapPath + 'normal')
      }, {
        value: 1,
        label: $t(mapPath + 'unavailable')
      }]
    case 'member':
      return [{
        value: 0,
        label: $t(mapPath + 'ok')
      }, {
        value: 1,
        label: $t(mapPath + 'disabled')
      }, {
        value: 2,
        label: $t(mapPath + 'deleting')
      }, {
        value: 3,
        label: $t(mapPath + 'deleted'),
        disabled: true
      }, {
        value: 4,
        label: $t(mapPath + 'suspended')
      }]
    case 'enabled':
      return [{
        value: 0,
        label: $t(mapPath + 'ok')
      }, {
        value: 1,
        label: $t(mapPath + 'disabled')
      }]
    case 'show':
      return [{
        value: 0,
        label: $t(mapPath + 'show')
      }, {
        value: 1,
        label: $t(mapPath + 'hide')
      }]
    case 'hide':
      return [{
        value: 0,
        label: $t(mapPath + 'hide')
      }, {
        value: 1,
        label: $t(mapPath + 'show')
      }]
    case 'category':
      return [{
        value: 0,
        label: $t(mapPath + 'show')
      }, {
        value: 1,
        label: $t(mapPath + 'hide')
      }, {
        value: 2,
        label: $t(mapPath + 'disabled')
      }]
    case 'product':
      return [{
        value: 0,
        label: $t(mapPath + 'show')
      }, {
        value: 2,
        label: $t(mapPath + 'nosale')
      }, {
        value: 4,
        label: $t(mapPath + 'hide')
      }]
    case 'orders':
      mapPath = mapPath + 'orders.'
      return [{
        value: 0,
        label: $t(mapPath + '_0_Create')
      }, {
        value: 1,
        label: $t(mapPath + '_1_Txn')
      }, {
        value: 2,
        label: $t(mapPath + '_2_OK')
      }, {
        value: 3,
        label: $t(mapPath + '_3_Fail')
      }, {
        value: 4,
        label: $t(mapPath + '_4_Cancel')
      }, {
        value: 5,
        label: $t(mapPath + '_5_Release')
      }, {
        value: 6,
        label: $t(mapPath + '_6_Refund100')
      }, {
        value: 7,
        label: $t(mapPath + '_7_Refund70')
      }, {
        value: 8,
        label: $t(mapPath + '_8_Trans')
      }, {
        value: 9,
        label: $t(mapPath + '_9_APPRefund100')
      }, {
        value: 10,
        label: $t(mapPath + '_10_APPRefund70')
      }, {
        value: 11,
        label: $t(mapPath + '_11_ExpiredErr')
      }]
    case 'reservation':
      mapPath = mapPath + 'reservation.'
      return [{
        value: 0,
        label: $t(mapPath + '_0_Book')
      }, {
        value: 1,
        label: $t(mapPath + '_1_WalkIn')
      }, {
        value: 2,
        label: $t(mapPath + '_2_CustomerCancel')
      }, {
        value: 3,
        label: $t(mapPath + '_3_BranchCancel')
      }, {
        value: 4,
        label: $t(mapPath + '_4_NoShow')
      }]
    case 'txn':
      mapPath = mapPath + 'txn.'
      return [{
        value: 0,
        label: $t(mapPath + '_0_Create')
      }, {
        value: 1,
        label: $t(mapPath + '_1_OK')
      }, {
        value: 2,
        label: $t(mapPath + '_2_Fail')
      }, {
        value: 3,
        label: $t(mapPath + '_3_Release')
      }]
    case 'refund':
      mapPath = mapPath + 'refund.'
      return [{
        value: 0,
        label: $t(mapPath + '_0_None')
      }, {
        value: 1,
        label: $t(mapPath + '_1_OK')
      }, {
        value: 2,
        label: $t(mapPath + '_2_Fail')
      }]
    case 'invoice':
      mapPath = mapPath + 'invoice.'
      return [{
        value: 0,
        label: $t(mapPath + '_0_None')
      }, {
        value: 1,
        label: $t(mapPath + '_1_Auto')
      }, {
        value: 2,
        label: $t(mapPath + '_2_OK')
      }, {
        value: 3,
        label: $t(mapPath + '_3_Fail')
      }, {
        value: 4,
        label: $t(mapPath + '_4_Allow')
      }, {
        value: 5,
        label: $t(mapPath + '_5_Invalid')
      }, {
        value: 6,
        label: $t(mapPath + '_6_InvalidFail')
      }, {
        value: 7,
        label: $t(mapPath + '_7_NoNeed')
      }]
    case 'email':
      mapPath = mapPath + 'email.'
      return [{
        value: 0,
        label: $t(mapPath + '_0_NeedConfirm')
      }, {
        value: 1,
        label: $t(mapPath + '_1_WaitToSend')
      }, {
        value: 2,
        label: $t(mapPath + '_2_Sending')
      }, {
        value: 3,
        label: $t(mapPath + '_3_Success')
      }, {
        value: 4,
        label: $t(mapPath + '_4_Fail')
      }]
    case 'export':
      mapPath = mapPath + 'export.'
      return [{
        value: 0,
        label: $t(mapPath + '_0_Running')
      }, {
        value: 1,
        label: $t(mapPath + '_1_Done')
      }, {
        value: 2,
        label: $t(mapPath + '_2_Failed')
      }]
    case 'blog':
      mapPath = mapPath + 'blog.'
      return [{
        value: 0,
        label: $t(mapPath + '_0_Draft')
      }, {
        value: 1,
        label: $t(mapPath + '_1_Published')
      }, {
        value: 2,
        label: $t(mapPath + '_2_Hidden')
      }]
    case 'ordersReceipt':
      mapPath = mapPath + 'ordersReceipt.'
      return [{
        value: 0,
        label: $t(mapPath + '_0_Created')
      }, {
        value: 1,
        label: $t(mapPath + '_1_Success')
      }, {
        value: 2,
        label: $t(mapPath + '_2_Fail')
      }]
    case 'gift':
      mapPath = mapPath + 'gift.'
      return [{
        value: 0,
        label: $t(mapPath + '_0_Created')
      }, {
        value: 1,
        label: $t(mapPath + '_1_Received')
      }, {
        value: 2,
        label: $t(mapPath + '_2_Reserved')
      }, {
        value: 3,
        label: $t(mapPath + '_3_Canceled')
      }, {
        value: 4,
        label: $t(mapPath + '_4_Expired')
      }]
    case 'deletion':
      mapPath = mapPath + 'deletion.'
      return [{
        value: 0,
        label: $t(mapPath + 'applied')
      }, {
        value: 1,
        label: $t(mapPath + 'verified')
      }, {
        value: 2,
        label: $t(mapPath + 'data_deleted')
      }]
    case 'partnerStatus':
      mapPath = mapPath + 'partnerStatus.'
      return [{
        value: -1,
        label: $t(mapPath + 'noUpload')
      }, {
        value: 0,
        label: $t(mapPath + 'noSale')
      }, {
        value: 1,
        label: $t(mapPath + 'onSale')
      }]
  }
  return []
}

export function getEditLogMap () {
  return {
    platform: [{
      value: 0,
      label: this.$t('api.editLog.platform.admin')
    }, {
      value: 1,
      label: this.$t('api.editLog.platform.bossnow')
    }, {
      value: 2,
      label: this.$t('api.editLog.platform.funnow')
    }, {
      value: 3,
      label: this.$t('api.editLog.platform.system')
    }, {
      value: 4,
      label: this.$t('api.optFields.authType.map.partner')
    }, {
      value: 5,
      label: this.$t('api.optFields.authType.map.rwg')
    }],
    action: [{
      value: 0,
      label: this.$t('api.editLog.action.add')
    }, {
      value: 1,
      label: this.$t('api.editLog.action.edit')
    }, {
      value: 2,
      label: this.$t('api.editLog.action.del')
    }],
    penaltyType: [{
      value: 0,
      label: this.$t('api.optFields.penaltyType.editLogMap.cancel')
    }, {
      value: 1,
      label: this.$t('api.optFields.penaltyType.editLogMap.noShow')
    }],
    penaltySkipPayment: [{
      value: true,
      label: this.$t('api.optFields.skipPayment.editLogMap.true')
    }]
  }
}

export function getStatusField (name) {
  return name + '_status'
}

export function getHumanLang () {
  switch (this.$store.getters.language) {
    case 'zh-TW':
      return 'zh_TW'
    case 'zh-CN':
      return 'zh_CN'
    default:
      return 'en'
  }
}

export function convLang (lang) {
  // @NOTE convert ja to ja-JP for backend API
  if (lang === 'ja') {
    return 'ja-JP'
  }
  return lang
}

export function convAOSLang (lang) {
  switch (lang) {
    case 'en-US':
      return 'en'
    case 'ms-MY':
      return 'ms'
    case 'th-TH':
      return 'th'
  }
  return lang
}
